// エラーメッセージ
export const MESSAGE_DUPLICATION_MAILADDRESS =
	'このメールアドレスは既に別のGakkenIDでご登録済みのため使用できません。別のメールアドレスをご使用ください。解決しない場合は、GakkenIDのよくあるご質問をご参照ください。';

export const MESSAGE_DUPLICATION_MAILADDRESS_SHORT = '既に登録されているメールアドレスです。';

export const MESSAGE_PASSWORD_ANNOTATION =
	'※大文字、小文字、数字を含む半角8文字以上で、推測されにくいパスワードを設定してください。';

export const TARGET_MESSAGE_PASSWORD_POPOVER = '推測されにくいパスワード';

export const POPOVER_MESSAGE_PASSWORD_ANNOTATION = `下記のような推測しやすいパスワードは避けてください。
・GakkenIDと同じもの
・自分や家族の名前、ペットの名前、生年月日など
・同じ文字の繰り返しやわかりやすい並びの文字列`;

export const CONFIRM_ERROR_PASSWORD = '新しいパスワードと新しいパスワード（確認）が一致していません。';

export const HARD_TO_GUESS_PASSWORD = '推測されにくいパスワードを選択してください。';
